export default __webpack_public_path__ + "img/mpc-pump-slots-awareness.c30d73b7.jpg";